/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityarchetypelabeldreamer3Inputs */



/**
* | output |
* | --- |
* | "The Dreamcatcher" |
*
* @param {Personalityarchetypelabeldreamer3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityarchetypelabeldreamer3 = /** @type {((inputs?: Personalityarchetypelabeldreamer3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityarchetypelabeldreamer3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The Dreamcatcher")
	if (locale === "es") return /** @type {LocalizedString} */ ("El Atrapasueños")
	return /** @type {LocalizedString} */ ("Ловец снов")
});
export { personalityarchetypelabeldreamer3 as "personalityArchetypeLabelDreamer" }